export const state = {
  username: "zackspear",
  apikey: "71a93af49daeb9f28cfaf5d1359995f9",
  artist: "Oasis",
  song: "Don't Look Back in Anger",
  loading: true,
  error: ""
};
